// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V22H10.501L10.5 18.5445L14.7294 14.3151L9 8.58579L4 13.5858V4H20V9.47063L22 11.4706V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16 5.25C14.4812 5.25 13.25 6.48122 13.25 8C13.25 9.51878 14.4812 10.75 16 10.75C17.5188 10.75 18.75 9.51878 18.75 8C18.75 6.48122 17.5188 5.25 16 5.25Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23.9143 16.2133L19.7867 12.0857L12.5 19.3724L12.5012 23.4999H16.6277L23.9143 16.2133ZM17.4507 17.2501L18.7499 18.5493L15.7993 21.4999H14.5006L14.5002 20.2006L17.4507 17.2501Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-image-edit-filled')
export default class ImageEditFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image-edit-filled',
    }
  }
}
